<template>
  <div class="toggle-section-item">
    <app-toggle v-model="internalValue"
                @input="onToggle"></app-toggle>

    <span class="ml-2">{{ permission.label }}</span>

    <app-confirmation-modal :value="pendingRemoval"
                            :confirm-label="$t('message.generics.message.confirm')"
                            @confirm="confirmRemoval"
                            @cancel="cancelRemoval">
      <span slot="heading">
        {{$t('message.admGenerics.message.deactivate')}} '{{ permission.label }}'
      </span>
      <span>
        {{$t('message.admGenerics.message.confirmDeactivation')}}
      </span>
    </app-confirmation-modal>
  </div>
</template>

<script>
import AppToggle from "@components/Toggle";
import AppConfirmationModal from "@components/ConfirmationModal";

export default {
  components: {
    AppToggle,
    AppConfirmationModal,
  },

  data() {
    return {
      pendingRemoval: false,
      internalValue: false,
    };
  },

  props: {
    permission: {
      type: Object,
    },
    userPermissions: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  watch: {
    userPermissions: {
      deep: true,
      handler() {
        this.setIternalVal();
      },
    },
  },

  created() {
    this.setIternalVal();
  },

  methods: {
    setIternalVal() {
      this.internalValue = !!this.userPermissions.find((permissionKey) => {
        return this.permission.key === permissionKey;
      });
    },
    cancelRemoval() {
      this.internalValue = true;
      this.pendingRemoval = false;
    },
    confirmRemoval() {
      this.pendingRemoval = false;

      this.$emit("toggle", this.permission.key);
    },
    onToggle(value) {
      if (value) {
        this.$emit("toggle", this.permission.key);
      } else {
        this.pendingRemoval = true;
      }
    },
  },

  computed: {},
};
</script>

<style scoped>
  .toggle-section-item {
    display: flex;
  }
</style>
